import Container from './Components/Container'
function App() {
  return(
    <Container/>
  );
}
export default App;
